import Slider from '../slider';

export default (element, data) => {
  const { layout, rotationNumber } = data;
  const rotationNumberConverted = rotationNumber * 1000
  let slider = null; 

  const initSlider = () => { 
    if (element.querySelector('[data-promo-slider]')) {
      slider = new Slider({
        el: element.querySelector('[data-promo-slider]'),
        options: { 
          slidesPerView: 1,
          loop: true,
          mousewheel: true,
          effect: 'fade',
          fadeEffect: { 
            crossFade: true
          },
          autoplay: {
            delay: rotationNumberConverted,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        },
      });
    }

    handleMobile();
    return slider;
  };

  const handleMobile = () => {
    const tradeProgramButton = document.querySelector('[data-header-tradeprogram]'); 
    if(!tradeProgramButton) return;

    if(layout.isAboveBreakpoint('lg')){
      tradeProgramButton?.removeAttribute('style');
      tradeProgramButton?.classList.remove(...['hover:bg-transparent','border-0']);
    } else {
      const promoBarMessage = document.querySelector('[data-promotional-banner-message]');
      const promoBarMessageColor = promoBarMessage?.style.color;
      tradeProgramButton.style.color = promoBarMessageColor;
      tradeProgramButton?.classList.add(...['hover:bg-transparent','border-0']);
    }
  };

  handleMobile();
  window.addEventListener('bpChange', handleMobile);
  initSlider();
};
